import React, { useState, useEffect, forwardRef,useRef,useMemo,useCallback } from "react";
import "datatables.net-dt/js/dataTables.dataTables";
import download1 from "../../../../src/assets/images/download 1.svg";
import download2 from "../../../../src/assets/images/download2.svg";
import { Modal } from "@appkit4/react-components/modal";
import ModalFooter from "@appkit4/react-components/esm/modal/ModalFooter";
import { Select } from "@appkit4/react-components/select";
import { Switch } from "@appkit4/react-components/switch";
import { Formik } from "formik";
import * as Yup from "yup";
import displayToastMessage from "../../../../src/components/Common/Alert/displayToastMessage";
import * as XLSX from "@e965/xlsx";
import NewDateString from '../../Common/newDateString.js'
import PropTypes from "prop-types";
import APIService from "../../../services/apiAxiosService.js";
import useHttp from "../../../hooks/useHttp.js";
import { AgGridReact } from "ag-grid-react"; // React Grid Logic
import { getMimetype } from "../../Common/FileValidation.js";
export default function CreateWorkProgram(props) {

  function MimeTypeOtherDoc(uploadedfile) {
    return new Promise((resolve, reject) => {

        if (uploadedfile.name) {
          const fileReader = new FileReader();
          fileReader.readAsArrayBuffer(uploadedfile);

          fileReader.onload = function (e) {
            // get file content
            const uint = new Uint8Array(e.target.result).subarray(0, 4);
            let bytes = [];
            uint.forEach((byte) => {
              bytes.push(byte.toString(16));
            });
            const hex = bytes.join("").toUpperCase();
            
               resolve({hex: hex, type: uploadedfile.type});
             
          };
          fileReader.onerror = reject;

        }
    });
  }

  
  const InitialValues = {
    workProgaramOwner: props.WorkProgramData
      ? props.WorkProgramData[0].workprogramowner
      : "",
    workProgaramName: props.WorkProgramData
      ? props.WorkProgramData[0].workprogramname
      : "",
    workProgram: props.WorkProgramData
      ? JSON.parse(props.WorkProgramData[0].filename)
      : [],
    instructions: props.WorkProgramData
      ? props.WorkProgramData[0].instructions
      : "",
    workProgramType: props.WorkProgramData
      ? props.WorkProgramData[0].workprogramcategory
      : "",
    validityFrom: props.WorkProgramData
      ? props.WorkProgramData[0].validfrom.split("T")[0]
      : "",
    validityTo: props.WorkProgramData
      ? props.WorkProgramData[0].validtill.split("T")[0]
      : "",
  };

  const dropdownData = [
    {
      value: 1,
      label: "Control Work Program",
    },
    {
      value: 2,
      label: "Questionnaire Work Program",
    },
  ];

  const dropdownTemplate = [
    {
      value: 1,
      label: "Questionnaire",
    },
    {
      value: 2,
      label: "Domain",
    },
  ];

  useEffect(() => {
    getAllVendorListData();
    if (props.WorkProgramData) {
      getSelectedFilesList(
        props.WorkProgramData[0].workprogramcategory === 1
          ? "domain"
          : "questionnaire"
      );
    }
  }, []);

  const { sendRequest: getAllVendorList } = useHttp();
  const { sendRequest: downloadTemplate } = useHttp();
  const { sendRequest: createWorkProgram } = useHttp();
  const { sendRequest: getExcelTableDate } = useHttp();
  const { sendRequest: addFile } = useHttp();
  const { sendRequest: getAllFiles } = useHttp();
  const { sendRequest: handleNotificationSubmitAPI } = useHttp();
  const [modalVisible, setmodalVisible] = useState(false);
  const [selectedTemplateTable, setSelectedTemplateTable] = useState([]);
  const [btnLoader, setBtnLoader] = useState(false);
  const [templateSelection, setTemplateSelection] = useState(null);
  const [selectedType, setSelectedType] = useState(
    props.WorkProgramData ? props.WorkProgramData[0].workprogramcategory : null
  );
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [tableData, setTableData] = useState(
    props.WorkProgramData
      ? JSON.parse(props.WorkProgramData[0].category_data)
      : []
  );
  const [typeFlag, setTypeFlag] = useState(
    props.WorkProgramData ? "update" : "create"
  );
  const [gridApi, setGridApi] = useState(null);

   // Apply settings across all columns
   const defaultColDef = useMemo(() => ({
    // Enable filtering on all columns,
    // flex:1,
    sortable: true,
    wrapText: true,     
    autoHeight: true,  
  }));

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const clickDownloadTemplate = async () => {
    await downloadTemplate(APIService.downloadTemplate(), (result) => {
      if (result) {
        const blob = new Blob([result], {
          type: "application/vnd.ms-excel",
        });
  
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
  
        link.href = url;
        link.setAttribute("download", "Work Program Template.xlsx");
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
        displayToastMessage("File Downloaded successfully", "success");
      }
    }, () => {
      let MSG = "Something went wrong, Please try again!";
      displayToastMessage(MSG, "error");
    })
  } 


  const getAllVendorListData = async () => {
    getAllVendorList(APIService.getAllVendorList(), (data) => {
      setVendors(data.MSG);
    });
  };

  let visibleToggle = (rowData, type) => {
    let keys = Object.keys(rowData);

    if (type === "Domain") {
      return !!(keys.includes("Domain") && keys.includes("Sub Domain"));
    } else if (type === "subDomain") {
      return !!(keys.includes("Sub Domain"));
    } else if (type === "area") {
      return !!(keys.includes("Area") && keys.includes("Sub Area"));
    } else if (type === "subArea") {
      return !!(keys.includes("Sub Area"));
    }
  };

  let handleCheckFieldValue = (rowData, type, value) => {
    let rowId = rowData?.node?.rowIndex;
    let UpdatedTableDta = [...tableData];

    if (type === "domain") {
      let i;
      for (i = rowId; i < tableData.length; i++) {
        let keys = Object.keys(tableData[i]);
        if (keys.includes("Domain") && !(i === rowId)) {
          break;
        } else {
          UpdatedTableDta[i].domainToggle = value;
          UpdatedTableDta[i].subDomainToggle = value;
          UpdatedTableDta[i].controlIDToggle = value;
        }
      }
    } else if (type === "subDomain") {
      let i;
      //CHECKING FOR PARENT ON STATE(IF PARENT FALSE CHILD CAN NOT BE TRUE)
      if (value === true) {
        for (i = rowId; i >= 0; i--) {
          let keys = Object.keys(tableData[i]);
          if (keys.includes("Domain")) {
            //CHECKING FOR PARENT
            if (UpdatedTableDta[i].domainToggle) {
              //CHECKING FOR PARENT STATE(ON/OFF)
              for (i = rowId; i < tableData.length; i++) {
                let keys = Object.keys(tableData[i]);
                if (keys.includes("Sub Domain") && !(i === rowId)) {
                  break;
                } else {
                  UpdatedTableDta[i].subDomainToggle = value;
                  UpdatedTableDta[i].controlIDToggle = value;
                  //     if(keys.includes("Sub Domain") ){//
                  //         UpdatedTableDta[i].subDomainToggle = value;
                  //         UpdatedTableDta[i].controlIDToggle = true;
                  //     }
                  //    else{UpdatedTableDta[i].controlIDToggle = false;}
                }
              }
            }
            break;
          }
        }
      } else {
        for (i = rowId; i < tableData.length; i++) {
          let keys = Object.keys(tableData[i]);
          if (keys.includes("Sub Domain") && !(i === rowId)) {
            break;
          } else {
            UpdatedTableDta[i].subDomainToggle = value;
            UpdatedTableDta[i].controlIDToggle = value;
          }
        }
      }
    } else if (type === "controlID") {
      let i;
      if (value === true) {
        for (i = rowId; i >= 0; i--) {
          //LOOPS BACK FOR IT's PARENTS.
          let keys = Object.keys(tableData[i]);
          if (keys.includes("Sub Domain")) {
            //CHECKING FOR PARENT
            if (UpdatedTableDta[i].subDomainToggle) {
              //CHECKING FOR PARENT STATE(ON/OFF)
              UpdatedTableDta[rowId].controlIDToggle = value;
            }
            break; //BREAKS WHEN IT REACHES TO IT'S PARENT(SUB DOMAIN).
          }
        }
      } else {
        let allChildStatus = false;

        let startIndex;
        for (let j = rowId; j >= 0; j--) {
          let keys = Object.keys(tableData[j]);
          if (keys.includes("Sub Domain")) {
            startIndex = j;
            break;
          }
        }
        let endIndex;
        for (let k = startIndex + 1; k < tableData.length; k++) {
          let keys = Object.keys(tableData[k]);
          if (keys.includes("Sub Domain")) {
            endIndex = k - 1;
            break;
          } else {
            endIndex = k;
          }
        }
        //WITH START AND END INDEX SEARCH FOR TRUE AND FALSE OF CONTROL ID, IF ALL DOMAINS ARE FALSE THEN SUB-DOMAINS WILL BE FALSE.
        for (let l = startIndex; l <= endIndex; l++) {
          if (l !== rowId && UpdatedTableDta[l].controlIDToggle === true) {
            allChildStatus = true;
            break;
          }
        }
        if (allChildStatus) {
          for (let l = startIndex; l <= endIndex; l++) {
            let keys = Object.keys(tableData[l]);
            if (keys.includes("Sub Domain")) {
              UpdatedTableDta[l].subDomainToggle = true;
            } else {
              UpdatedTableDta[l].subDomainToggle = true;
            }
          }
        } else {
          if (startIndex === tableData.length - 1) {
            endIndex = startIndex;
          }
          for (let l = startIndex; l <= endIndex; l++) {
            UpdatedTableDta[l].subDomainToggle = false;
          }
        }

        UpdatedTableDta[rowId].controlIDToggle = value; //THE SELECTED WILL BE FALSE
      }
    } else if (type === "area") {
      let i;
      for (i = rowId; i < tableData.length; i++) {
        let keys = Object.keys(tableData[i]);
        if (keys.includes("Area") && !(i === rowId)) {
          break;
        } else {
          UpdatedTableDta[i].areaToggle = value;
          UpdatedTableDta[i].subAreaToggle = value;
          UpdatedTableDta[i].questionIDToggle = value;
        }
      }
    } else if (type === "subArea") {
      let i;
      for (i = rowId; i < tableData.length; i++) {
        let keys = Object.keys(tableData[i]);
        if (keys.includes("Sub Area") && !(i === rowId)) {
          break;
        } else {
          UpdatedTableDta[i].subAreaToggle = value;
          UpdatedTableDta[i].questionIDToggle = value;
        }
      }
    } else if (type === "questionID") {
      // UpdatedTableDta[rowId].questionIDToggle = value;
      let i;
      if (value === true) {
        for (i = rowId; i >= 0; i--) {
          //LOOPS BACK FOR IT's PARENTS.
          let keys = Object.keys(tableData[i]);
          if (keys.includes("Sub Domain")) {
            //CHECKING FOR PARENT
            if (UpdatedTableDta[i].subDomainToggle) {
              //CHECKING FOR PARENT STATE(ON/OFF)
              UpdatedTableDta[rowId].controlIDToggle = value;
            }
            break; //BREAKS WHEN IT REACHES TO IT'S PARENT(SUB DOMAIN).
          }
        }
      } else {
        let allChildStatus = false;

        let startIndex;
        for (let j = rowId; j >= 0; j--) {
          let keys = Object.keys(tableData[j]);
          if (keys.includes("Sub Area")) {
            startIndex = j;
            break;
          }
        }
        let endIndex;
        for (let k = startIndex + 1; k < tableData.length; k++) {
          let keys = Object.keys(tableData[k]);
          if (keys.includes("Sub Area")) {
            endIndex = k - 1;
            break;
          } else {
            endIndex = k;
          }
        }
        //WITH START AND END INDEX SEARCH FOR TRUE AND FALSE OF CONTROL ID, IF ALL DOMAINS ARE FALSE THEN SUB-DOMAINS WILL BE FALSE.
        for (let l = startIndex; l <= endIndex; l++) {
          if (l !== rowId && UpdatedTableDta[l].questionIDToggle === true) {
            allChildStatus = true;
            break;
          }
        }
        if (allChildStatus) {
          for (let l = startIndex; l <= endIndex; l++) {
            let keys = Object.keys(tableData[l]);
            if (keys.includes("Sub Area")) {
              UpdatedTableDta[l].subAreaToggle = true;
            } else {
              UpdatedTableDta[l].subAreaToggle = true;
            }
          }
        } else {
          if (startIndex === tableData.length - 1) {
            endIndex = startIndex;
          }
          for (let l = startIndex; l <= endIndex; l++) {
            UpdatedTableDta[l].subAreaToggle = false;
          }
        }

        UpdatedTableDta[rowId].questionIDToggle = value; //THE SELECTED WILL BE FALSE
      }
    }
    setTableData(UpdatedTableDta);
};

  const getFilesNames = (selected) => {
    let type = "";
    setSelectedType(selected);
    if (selected === 1) {
      setTableData([]);
      type = "domain";
    } else {
      setTableData([]);
      type = "questionnaire";
    }
    getSelectedFilesList(type);
  };

  let getSelectedFilesList = async (type) => {
    getAllFiles(
      APIService.getAllFiles(type),
      (result) => {
        if (result.CODE) {
          setSelectedFiles(result.MSG);
        }
      },
      errorHandler
    );
  };

  const errorHandler = () => {
    let MSG = "Something went wrong, Please try again!";
    displayToastMessage(MSG, "error");
  };

  const onCellValueChanged = ((event) => {
    var data = event.data;
    const dataUpdate = [...tableData];
    const index = event.rowIndex;
    dataUpdate[index] = data;
    setTableData([...dataUpdate]);
  });


  const handleSubmit = async (values, { resetForm }) => {
    setBtnLoader(true);
    tableData.map((item) => {
      let newData = [];
      let keys = Object.keys(item);
      if (keys.includes("Domain")) {
        if (item.domainToggle === true) {
          newData.push(item);
        }
      }
      return newData;
    });

    let jsonArray = [];
    let data = {
      email:sessionStorage.getItem("email"),
      flag: typeFlag,
      paramWorkProgramStatus: "Created",
      paramUserID: Number(sessionStorage.getItem("userId")),
      paramWorkProgram: values.workProgaramName,
      paramInstructions: values.instructions,
      paramWorkProgramOwner: values.workProgaramOwner,
      paramFileName: values.workProgram,
      paramworkprogramcategory: values.workProgramType,
      paramValidFrom: new Date(values.validityFrom),
      paramValidTo: new Date(values.validityTo),
      paramCategoryData: JSON.stringify(tableData),
      paramWorkProgramID: Number(props.workProgramID),
    };

    jsonArray.push(data);
    createWorkProgram(
      APIService.createWorkProgram(jsonArray),
      (result) => {
        if (result.CODE) {
          displayToastMessage(result.MSG, "success");
          let notifData = {
            paramuserid: Number(sessionStorage.getItem("userId")),
            paramreqid: Number(values.vendorName),
            paramcontent: "created work program",
            paramnextroleid: 2,
            paramcreatedby: Number(sessionStorage.getItem("roleId")),
            parammsgtype: result.MSG,
          };
          handleNotificationSubmitAPI(
            APIService.handleNotificationSubmit(notifData),
            () => {}
          );
        }
        props.sendBack();
        resetForm();
        setTableData([]);
      },
      errorHandler
    );
    setBtnLoader(false);
  };

  const validationSchema = Yup.object().shape({
    workProgaramOwner: Yup.string()
      .required("work Program Owner is required")
      .matches(
        /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
        "Only alphabets and numbers are allowed for this field "
      ),
    workProgaramName: Yup.string()
      .required("Work program name is required")
      .matches(
        /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
        "Only alphabets and numbers are allowed for this field "
      ),
    workProgram: Yup.array().min(1).required("Work program is required"),
    instructions: Yup.string()
      .required("Instructions (if any) is required")
      .matches(
        /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
        "Only alphabets and numbers are allowed for this field "
      ),
    workProgramType: Yup.string().required("Work program type is required"),
    validityFrom: Yup.string().required("Validity from is required"),
    validityTo: Yup.string().required("Validity to is required"),
  });
  const handleCancel = () => {
    setmodalVisible(false);
  };

  const handleConfirm = () => {
    let msg = "Request has been created successfully";
    displayToastMessage(msg, "success");
    setmodalVisible(false);
    props.sendBack();
  };

  const fileReaderHandler = async (e) => {
    MimeTypeOtherDoc(e.target.files[0]).then((img) => {
      if (getMimetype(img.hex, img.type)) {
        let newFile = {};
    newFile.name = e.target.files[0].name;

    let files = e.target.files,
      f = files[0];

    let reader = new FileReader();
    reader.onload = (evt) => {
      // evt = on_file_select event
      /* Parse data */
      const bstr = evt.target.result;
      let b64 = btoa(bstr);
      newFile.base64File = b64;
      const wb = XLSX.read(bstr, { type: "binary" });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
      /* Update state */
      let headingRow = data[0];

      if (
        headingRow[0] === "SNo" &&
        headingRow[1] === "Domain" &&
        headingRow[2] === "S.No Sub Domain" &&
        headingRow[3] === "Sub Domain" &&
        headingRow[4] === "Control ID" &&
        headingRow[5] === "Control Definition" &&
        headingRow[6] === "Control Testing Procedure" &&
        headingRow[7] === "Attachment required" &&
        headingRow[8] === "Attachment Type"
      ) {
        fileHandleUpload(newFile, "domain", img.hex, img.type);
      } else if (
        headingRow[0] === "SNo" &&
        headingRow[1] === "Area" &&
        headingRow[2] === "Sub Area" &&
        headingRow[3] === "Question Id" &&
        headingRow[4] === "Question" &&
        headingRow[5] === "Instructions (If any)" &&
        headingRow[6] === "Attachment required" &&
        headingRow[7] === "Attachment Type"
      ) {
        fileHandleUpload(newFile, "questionnaire", img.hex, img.type);
      } else {
        displayError();
      }
    };
    reader.readAsBinaryString(f);
    } else {
      displayToastMessage("Please upload a valid, non-empty file.",'error');
    }
    })
  };

  const displayError = () => {
    displayToastMessage("Please add xlsx file", "error");
  };

  const responseHandler = (result) => {
    if (result.CODE) {
      displayToastMessage(result.MSG, "success");
      getFilesNames();
    }
  };

  const fileHandleUpload = async (newFile, type, hex, fileType) => {
    let data = { ...newFile, fileType: type, hex: hex, type: fileType };
    addFile(APIService.addFile(data), responseHandler, errorHandler);
  };

  const selectedTemplates = async (files, workProgramType) => {
    let fileNames = [[files], workProgramType];
    getExcelTableDate(
      APIService.getExcelTableDate(fileNames),
      (result) => {
        if (result.CODE) {
          let data;

          if (workProgramType === 1) {
            data = [...result.MSG];

            data.forEach((item) => {
              item.domainToggle = true;
              item.subDomainToggle = true;
              item.controlIDToggle = true;
            });
          } else {
            data = [...result.MSG];

            data.forEach((item) => {
              item.areaToggle = true;
              item.subAreaToggle = true;
              item.questionIDToggle = true;
            });
          }
          setSelectedTemplateTable(result.MSG);
          setTableData(result.MSG);
        }
      },
      errorHandler
    );
  };

  const rowStyle = { background: 'white' };

  const handleSelectTemplate = (e) => {
    setTemplateSelection(e);
  }


  return (
    <div className="App">
      <div className="row mt-2">
        <div className="col-md-8">
        </div>
        <div className="col-md-3 ms-5 download-template-alignment">
          <Select
            className="cv-input-field"
            data={dropdownTemplate}
            placeholder="Select Download Template"
            onSelect={handleSelectTemplate}
          ></Select>
          <span className={templateSelection !== 1 ? "Appkit4-icon icon-download-fill pointer downloadSizeAlignment disbaledDownloadTemplate" : "Appkit4-icon icon-download-fill pointer downloadSizeAlignment"} title="Download template" onClick={clickDownloadTemplate}></span>
          <span
            className="Appkit4-icon icon-arrow-left-outline pointer back-fill padding-left"
            onClick={props.sendBack}
          ></span>
          </div>

        
      </div>
      <Formik
        initialValues={InitialValues}
        onSubmit={handleSubmit}
        validationSchema={validationSchema}
      >
        {(prop) => {
          const {
            values,
            touched,
            errors,
            handleChange,
            handleBlur,
            handleSubmit,
          } = prop;
          return (
            <form onSubmit={handleSubmit}>
              <div className="row mt-3">
                <div className="col-sm-6">
                  <div className="cv-input-field-container pt-0 pb-0">
                    <label htmlFor="WPNameControlWP" className="cv-input-label">
                      Work Program Name <span className="asterisk-required">*</span>
                    </label>
                    <input
                      className="cv-input-field p-l-13"
                      onBlur={handleBlur}
                      id="WPNameControlWP"
                      type="text"
                      value={values.workProgaramName}
                      onChange={handleChange("workProgaramName")}
                      name="Work Program Name"
                      placeholder={"Enter Work Program Name"}
                    />
                  </div>
                  {errors.workProgaramName && touched.workProgaramName && (
                    <div className="form-label error">
                      {errors.workProgaramName}
                    </div>
                  )}
                </div>
                <div className="col-sm-6">
                  <div className="cv-input-field-container pt-0 pb-0">
                    <label htmlFor="WPOwnerControlWP" className="cv-input-label">
                      Work Program Owner <span className="asterisk-required">*</span>
                    </label>
                    <input
                      className="cv-input-field p-l-13"
                      onBlur={handleBlur}
                      id="WPOwnerControlWP"
                      type="text"
                      value={values.workProgaramOwner}
                      onChange={handleChange("workProgaramOwner")}
                      name="Work Program Owner"
                      placeholder={"Enter Work Program owner"}
                    />
                  </div>
                  {errors.workProgaramOwner && touched.workProgaramOwner && (
                    <div className="form-label error">
                      {errors.workProgaramOwner}
                    </div>
                  )}
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <div className="cv-input-field-container pt-0 pb-0">
                    <label className="cv-input-label">
                      Work Program Type{" "}
                      <span className="asterisk-required">*</span>
                    </label>
                    <Select
                      showSearchOnToggle={true}
                      dropdownRenderMode="portal"
                      searchable={true}
                      data={dropdownData}
                      className="cv-input-field"
                      onSelect={(e) => {
                        handleChange("workProgramType")({
                          target: { value: e },
                        });
                        //handlechange for workprogram for empty of array for every time
                        handleChange("workProgram")({ target: { value: [] } });
                        selectedTemplates([], e);
                        getFilesNames(e);
                      }}
                      name="Previous Assessment Report"
                      value={values.workProgramType}
                      placeholder={"Select Work Program Type"}
                    ></Select>
                  </div>
                  {errors.workProgramType && touched.workProgramType && (
                    <div className="form-label error">
                      {errors.workProgramType}
                    </div>
                  )}
                </div>
                <div className="col-sm-6">
                  <div className="cv-input-field-container pt-0 pb-0">
                    <label className="cv-input-label">
                      Select Work Program{" "}
                      <span className="asterisk-required">*</span>
                    </label>
                    <Select
                      showSearchOnToggle={true}
                      dropdownRenderMode="portal"
                      data={selectedFiles}
                      valueKey="filename"
                      labelKey="filename"
                      placeholder="Select Work Program"
                      className="p-l-6 cv-input-field"
                      multiple={true}
                      showSelectAll={false}
                      name=" Work Program"
                      onSelect={(e) => {
                        handleChange("workProgram")({ target: { value: e } });
                        selectedTemplates(e, values.workProgramType);
                      }}
                      value={values.workProgram}
                    ></Select>

                    <div className="add-media pointer">
                      <form className="m-auto">
                        <label htmlFor="file-upload" className="m-0">
                          <img
                            alt="edit"
                            className="edit-input"
                            style={{ transform: "rotate(-90deg)" }}
                            type="file"
                            src={download1}
                          />
                        </label>
                        <input
                          id="file-upload"
                          onChange={fileReaderHandler}
                          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                          type="file"
                          style={{ display: "none" }}
                        />
                      </form>
                    </div>
                  </div>
                  {errors.workProgram && touched.workProgram && (
                    <div className="form-label error">{errors.workProgram}</div>
                  )}
                </div>
              </div>

              <div className="row ">
                <div className="col-sm-6">
                  <div className="cv-input-field-container">
                    <label htmlFor="validityFromControlWP" className="cv-input-label">
                      Validity From <span className="asterisk-required">*</span>
                    </label>
                    <input
                      className="cv-input-field leftPadding"
                      id="validityFromControlWP"
                      type="date"
                      name="validity From"
                      min={props.WorkProgramData ? null : NewDateString()}
                      onBlur={handleBlur}
                      value={values.validityFrom}
                      onChange={handleChange("validityFrom")}
                    />
                  </div>
                  {errors.validityFrom && touched.validityFrom && (
                    <div className="form-label error">
                      {errors.validityFrom}
                    </div>
                  )}
                </div>

                <div className="col-sm-6">
                  <div className="cv-input-field-container">
                    <label htmlFor="validityToControlWP" className="cv-input-label">
                      Validity To <span className="asterisk-required">*</span>
                    </label>
                    <input
                      className="cv-input-field p-l-13"
                      type="date"
                      id="validityToControlWP"
                      name="LastAssessmentDate"
                      onBlur={handleBlur}
                      min={NewDateString(values.validityFrom)}
                      value={values.validityTo}
                      onChange={handleChange("validityTo")}
                    />
                  </div>
                  {errors.validityTo && touched.validityTo && (
                    <div className="form-label error">{errors.validityTo}</div>
                  )}
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <div className="cv-input-field-container pt-0 pb-0">
                    <label htmlFor="intructionsControlWP" className="cv-input-label">
                      Instructions (if any){" "}
                      <span className="asterisk-required">*</span>
                    </label>
                    <input
                      className="cv-input-field p-l-14"
                      onBlur={handleBlur}
                      id="intructionsControlWP"
                      type="text"
                      value={values.instructions}
                      onChange={handleChange("instructions")}
                      name="Instructions"
                      placeholder={"Please Add Instructions"}
                    />
                  </div>
                  {errors.instructions && touched.instructions && (
                    <div className="form-label error">
                      {errors.instructions}
                    </div>
                  )}
                </div>
              </div>
              <div className="row pt-5 pl-3">
                <div className="col-lg-12 mt-3 pl-1">
                  <div className="row p-1">
                    <div className="col-md-12">
                    <div className="ag-theme-alpine" style={{ height: 500, width: "100%" }}>
                          <AgGridReact
                            rowStyle={rowStyle}

                            rowData={tableData}
                            columnDefs={selectedType==1 ?
                              [
                                {
                                  headerName: "Select",
                                  field: "Select",
                                  cellRenderer: (rowData) =>
                                  visibleToggle(rowData.data, "Domain") && (
                                    <Switch
                                      checked={rowData.data.domainToggle}
                                      onChange={(e) =>
                                        handleCheckFieldValue(
                                          rowData,
                                          "domain",
                                          e
                                        )
                                      }
                                    ></Switch>
                                  ),
                                }, {
                                  headerName: "S.No",
                                  field: "SNo",
                                }, {
                                  headerName: "Domain",
                                  field: "Domain",
                                  editable:true,
                                }, {
                                  headerName: "Select",
                                  field: "Select",
                                  cellRenderer: (rowData) =>
                                  visibleToggle(rowData.data, "subDomain") && (
                                    <Switch
                                      checked={rowData.data.subDomainToggle}
                                      onChange={(e) =>
                                        handleCheckFieldValue(
                                          rowData,
                                          "subDomain",
                                          e
                                        )
                                      }
                                    ></Switch>
                                  ),
                                },{
                                  headerName: "S.No",
                                  field: "SNo",
                                  
                                },{
                                  headerName: "Sub Domain",
                                  field: "Sub Domain",
                                  editable:true,

                                 
                                },
                                { headerName: "Select", field: "Select", cellRenderer: (rowData) => (
                                  <Switch
                                    checked={rowData.data.controlIDToggle}
                                    onChange={(e) =>
                                      handleCheckFieldValue(
                                        rowData,
                                        "controlID",
                                        e
                                      )
                                    }
                                  ></Switch>
                                ), },
                                
                                {
                                  headerName: "Control ID",
                                  field: "Control ID",
                                  editable:true,

                                 
                                }, {
                                  headerName: "Control Definition",
                                  field: "Control Definition",
                                  editable:true,

                                 
                                }, {
                                  headerName: "Control Testing Procedure",
                                  field: "Control Testing Procedure",
                                  editable:true,

                                 
                                },{
                                  headerName: "Attachment required",
                                  field: "Attachment required",
                                  editable:true,

                                 
                                },{
                                  headerName: "Attachment Type",
                                  field: "Attachment Type",
                                  editable:true,

                                },]:[
                              {
                                headerName: "Select",
                                field: "Select",
                                editable: true,
                                cellDataType:'boolean',
                                cellRenderer: (rowData) =>
                                visibleToggle(rowData.data, "area") && (
                                  <Switch
                                    checked={rowData.data.areaToggle}
                                    onChange={(e) =>
                                      handleCheckFieldValue(
                                        rowData,
                                        "area",
                                        e
                                      )
                                    }
                                  ></Switch>
                                ),
                              },
                              { headerName: "S.No", field: "SNo"},
                              { headerName: "Area", field: "Area", editable: true },
                              { headerName: "Select",field: "Select",editable: true, cellRenderer: (rowData) =>
                              visibleToggle(rowData.data, "subArea") && (
                                <Switch
                                  checked={rowData.data.subAreaToggle}
                                  onChange={(e) =>
                                    handleCheckFieldValue(
                                      rowData,
                                      "subArea",
                                      e
                                    )
                                  }
                                ></Switch>
                              ),},
                              { headerName: "Sub Area",field: "Sub Area",editable: true},
                              { headerName: "Select", field: "Select",editable: true, cellRenderer: (rowData) => (
                                <Switch
                                  checked={rowData.data.questionIDToggle}
                                  onChange={(e) =>
                                    handleCheckFieldValue(
                                      rowData,
                                      "questionID",
                                      e
                                    )
                                  }
                                ></Switch>
                              ),
                              },
                              { headerName: "Question Id", field: "Question Id",editable: true },
                                                          { headerName: "Question", field: "Question",editable: true,width:400,cellEditor: "agLargeTextCellEditor",cellEditorPopup: true ,cellEditorParams: {
                                                            maxLength: 500
                                                        },},
                                                          {
                                                            headerName: "Instructions (If any)",
                                                            field: "Instructions (If any)",
                                                            editable: true,width:400,cellEditor: "agLargeTextCellEditor",cellEditorPopup: true,cellEditorParams: {
                                                              maxLength: 500
                                                          },
                                                          },
                                                          {
                                                            headerName: "Attachment required",
                                                            field: "Attachment required",
                                                            editable: true
                                                          },
                                                          {
                                                            headerName: "Attachment Type",
                                                            field: "Attachment Type",
                                                            editable: true
                                                          },
                             
                              
                            ]}
                            defaultColDef={defaultColDef}
                            pagination={true}
                            onCellValueChanged={onCellValueChanged}
                            onGridReady={onGridReady}
                          />
                        </div>
                    </div>
                  </div>
                </div>

                <div className="options-container">
                  {btnLoader ? (
                    <button
                      className="btn btn-secondary loading-btn mr-4"
                      type="button"
                      disabled
                    >
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <span className="pl-1">Loading...</span>
                    </button>
                  ) : (
                    props.viewScreen == false && (
                      <button type="submit" className="save-button mt-4 me-4">
                        {props.WorkProgramData ? "Update" : "Submit"}
                      </button>
                    )
                  )}

                  <button
                    className="cancel-button mt-4 me-3"
                    type="reset"
                    onClick={props.sendBack}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </form>
          );
        }}
      </Formik>

      <div>
        <Modal
          className="baseline-modal-showcase"
          visible={modalVisible}
          onCancel={handleCancel}
          bodyStyle={{ maxHeight: "280px" }}
          footerStyle={{ paddingTop: "8px", marginTop: "-8px" }}
          modalStyle={{ width: "49.75rem", maxHeight: "fit-content" }}
        >
          <div className="modal-title">
            Are you sure you want to submit the Request?
          </div>
          <ModalFooter>
            <div className="modal-footer">
              <button
                type="button"
                className="cancel-button"
                onClick={handleCancel}
              >
                No
              </button>

              <button
                type="submit"
                className="save-button m-l-2"
                onClick={handleConfirm}
              >
                Yes
              </button>
            </div>
          </ModalFooter>
        </Modal>
      </div>
    </div>
  );
}

CreateWorkProgram.propTypes = {
  WorkProgramData: PropTypes.any,
  workProgramID: PropTypes.any,
  sendBack: PropTypes.any,
  viewScreen: PropTypes.any
}
